/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/333-sort-amount-asc': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5 12V0H3v12H.5L4 15.5 7.5 12H5z"/><path pid="1" d="M7 9h9v2H7V9zM7 6h7v2H7V6zM7 3h5v2H7V3zM7 0h3v2H7V0z"/>'
  }
})
